import { Component, Inject, OnInit } from '@angular/core'
import { Router } from '@angular/router'

import { BootstrapData } from 'elements-sdk'
import { BOOTSTRAP_DATA } from 'api'
import { IdentityService } from 'main'
import { AppSidebarService } from 'main/services/appSidebar.service'

@Component({
  selector: 'index-view',
  template: '',
})
export class IndexViewComponent implements OnInit {
  constructor (
    private router: Router,
    private identity: IdentityService,
    private appSidebar: AppSidebarService,
    @Inject(BOOTSTRAP_DATA) private readonly bootstrapData: BootstrapData,
  ) { }

  ngOnInit (): void {
    if (this.bootstrapData.isPanel) {
      this.navigateThroughTo('/media')
      return
    }

    const defaultPage = this.identity.user?.defaultPage

    // Go to default if has permission
    for (const category of this.identity.knownPages) {
      const page = category.pages.find(x => x.id === defaultPage)
      if (page && this.appSidebar.havePagePermission(page)) {
        this.navigateThroughTo(page.url)
        return
      }
    }

    if (defaultPage?.startsWith('/download-redirect')) {
      this.identity.logout()
    }

    if (defaultPage?.startsWith('/')) {
      this.navigateThroughTo(defaultPage)
      return
    }

    // Otherwise, go to first available page
    for (const category of this.identity.knownPages) {
      for (const page of category.pages) {
        if (this.appSidebar.havePagePermission(page)) {
          this.navigateThroughTo(page.url)
          return
        }
      }
    }

    this.navigateThroughTo('/profile')
  }

  navigateThroughTo (url: string) {
    this.router.navigateByUrl(url, { replaceUrl: true, skipLocationChange: true })
  }
}
